/*===========================================================
bookmark.js
===========================================================*/
var item_bookmark_btn = "#item-detail-bookmark-btn .bookmark-btn, .arrive-item .bookmark-btn, .add-bookmark .bookmark-btn, #item-detail-select .icon.add-bookmark, .detail-cart-btns .icon.add-bookmark";
var item_bookmark_btn2 = ".list-bookmark .bookmark-btn";

$(function(){

   /*----------------------------------------

   -----------------------------------------*/

   var flag  = false;
   var delay = 1000;
   var itemname = "";

   /*---------------------------------
   bookmarkbtn1
   ---------------------------------*/

   $(item_bookmark_btn).click(function(e){

      var $thisBtn = $(this);
      var send_url = $thisBtn.attr('href');

      itemname = $(e.target).attr("title");
      itemId = send_url.match("item_id=([0-9]*)")[1];
      //alert(itemname)

      $.getJSON(send_url,function(json) {

         if(json[0]){
            var message = "お気に入り商品に登録しました";
            if($thisBtn.hasClass('bookmark_r-btn')){
               itemname = "";
               message = "お気に入りコーデに登録しました";
            }

            if ( !$thisBtn.hasClass('icon') ) {
               showMessage(message);
            }
            //ga('send', 'event', 'UX', 'bookmark item', itemId);

            /* XrossData 16.07.19追加 */
            if( typeof(__custom_param) === "object" && typeof(__push_beacon) === "function" && itemname !== "" ) {
                var oa = __action;
                __action = "favoritein";
                if( window.location.href.match(/:\/\/[^\/]+\/arrive/) ) {
                    var dd = $thisBtn.closest("dd");
                    var vu = dd.find("div.info h3 a").attr("href");
                    __custom_param = {
                        pid: itemId,
                        p_name: itemname,
                        p_price: jQuery("#item-price-"+itemId).text().replace(/[^0-9]/g,''),
                        p_img_url: jQuery("#item-thumb-"+itemId).attr("src"),
                        view_url: jQuery('<a>').attr('href',vu).get(0).href
                    };
                    var dp = dd.find("div.info p.price span.sale_price").text().replace(/[^0-9,]/g,'');
                    var lp = dd.find("div.info p.price span.default_price").text().replace(/[^0-9,]/g,'');
                    __custom_param.disp_list_price = lp;
                    if( dp ) {
                        __custom_param.disp_price = dp;
                        __custom_param.price_flg = 2;
                    } else {
                        __custom_param.disp_price = lp;
                        __custom_param.price_flg = 1;
                    }
                }
                __push_beacon(__getURL(), function(){__action=oa;});
            }
            /* XrossData ここまで */

         }else{
            if($thisBtn.hasClass('bookmark_r-btn')){
               itemname = "";
            }
            if ( !$thisBtn.hasClass('icon') ) {
               showMessage(json[1]);
            }
         }

         if ( $thisBtn.hasClass('icon') ) {
            $('.icon.add-bookmark', $thisBtn.parent()).hide();
            if ( $thisBtn.hasClass('added') ) {
               $('.icon.add-bookmark.not-added', $thisBtn.parent()).show();
            } else {
               $('.icon.add-bookmark.added', $thisBtn.parent()).show();
            }
         }

         return;
      });

      return false;

   });

   function showMessage(text){
      $('#container').append('<div class="alert-message"><div class="alert-message-name">'+itemname+'</div><div class="alert-message-text">'+text+'</div></div>');
      thisHeight = $(".alert-message").height()/2;
      thisWidth = $(".alert-message").width()/2;
      //alert(-thisHeight);
      $(".alert-message").css("margin-top",-thisHeight);
      $(".alert-message").css("margin-left",-thisWidth);
      $(".alert-message").animate({opacity:1},500,function(){
         var timer = setInterval(function(){
            clearInterval(timer);
            $(".alert-message").animate({opacity:0},500,function(){
               $(".alert-message").remove();
            });
         },delay);
      });
   }

   /*---------------------------------
   bookmarkbtn2
   ---------------------------------*/
   var target_id = "";
   var position_mode = "false";
   var height = 0;

   $(document).on("click", item_bookmark_btn2, function(){
      var send_url = $(this).attr('href');

      itemname = $(this).attr("title");


      target_id = "#"+$(this).parent().parent().parent().parent().attr("id");
      /*
      alert(target_id);

      $(".item-detail").css("z-index","20");
      $(target_id).css("z-index",100);

      if($(this).parent().parent().parent().parent().hasClass("position5")){
         position_mode = true;
      }else{
         position_mode = false;
      }

      height = $(this).parent().parent().parent().parent().height()+"px";
      //alert(height);
      */

      /* XrossData 16.07.19追加 */
      /*if( typeof(__push_beacon) === "function" ) {
          var dd = jQuery(this).closest(".box-child");
          var u = dd.children("div.thumb,div.top-newrecommend-item-image");
          var pr;
          var pf;
          var pl = dd.find(".default_price").text().replace(/[^0-9,]/g,'');
          if( dd.find(".sale_price")[0] ) {
              pr = dd.find(".sale_price").text().replace(/[^0-9,]/g,'');
              pf = 2;
          } else {
              pr = pl;
              pf = 1;
          }
          var m = send_url.match(/item_id=([0-9]+)/);
          var vu = u.children("a").attr("href");
          if( vu.indexOf("http") != 0 ) {
              vu = jQuery("<a>").attr('href',vu).get(0).href;
          }
          __custom_param = {
              pid: m[1],
              p_name: itemname,
              view_url: vu,
              p_img_url: u.find("img").attr("src"),
              p_price: pr.replace(/[^0-9]/g, ''),
              disp_price: pr,
              disp_list_price: pl,
              price_flg: pf
          };
      }*/
      /* XrossData ここまで */

      $.getJSON(send_url,function(json) {

         $("#container").append('<div class="alert-message"><div class="alert-message-name">送信中</div></div>');
         $(".alert-message").css("width","310px");

         /*if(position_mode){
            $(".alert-message").css('top',height);
            $(".alert-message").css('left', "-160px");
         }else{
            $(".alert-message").css('top',height);
         }*/

         $('.alert-message').fadeIn(function(){
            $(this).fadeOut(function(){
               $(".alert-message").remove();
               if(json[0]){
                  showMessage2("お気に入り商品に登録しました");

                  /* XrossData 16.07.19追加 */
                  if( typeof(__custom_param) === "object" &&
                      typeof(__push_beacon) === "function" ) {
                      var oa = __action;
                      __action = "favoritein";
                      __push_beacon(__getURL(), function(){__action=oa;});
                  }
                  /* XrossData ここまで */

               }else{
                  showMessage2(json[1]);
               }
            });
         });

         return;
      });

      return false;

   });

   function showMessage2(text){

      $("#container").append('<div class="alert-message"><div class="alert-message-name">'+itemname+'</div><div class="alert-message-text">'+text+'</div></div>');

      //$(".alert-message").css("width","310px");

      /*
      if(position_mode){
         $(".alert-message").css('top',height);
         $(".alert-message").css('left', "-160px");
      }else{
         $(".alert-message").css('top',height);
      }
      */

      $(".alert-message").animate({opacity:1},500,function(){
         var timer = setInterval(function(){
            clearInterval(timer);
            $(".alert-message").animate({opacity:0},500,function(){
               $(".alert-message").remove();
            });
         },delay);
      });
   }

});


/*ログイン前*/
$(function(){
   $(document).on("click", '.members-only-alert-btn', function(){
      var $popup = $('#members-only-alert');
      var loginURL = $(this).attr('data-href');
      $('.title',$popup).text('お気に入り商品に追加');
      $('.members-only-alert-link-login',$popup).attr('href',loginURL);
      $.fancybox.open($(this));
   });

});
